<template>
  <div class="toggle-container" ref="container">
    <div
      class="slider"
      :style="{
        left: sliderLeft + 'px',
        width: sliderWidth + 'px'
      }"
    ></div>
    <span ref="option0" :class="{ 'active' : selectedIndex === 0 }" @click="select(0)">
      {{ translate('rdCorporate') }}
    </span>
    <span ref="option1" :class="{'active' : selectedIndex === 1 }" @click="select(1)">
      {{ translate('rdPersonal') }}
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedIndex: 0,
      sliderLeft: 0,
      sliderWidth: 0
    }
  },
  props: {
    selectIndex: Number
  },
  mounted() {
    this.selectedIndex = this.selectIndex
    this.updateSlider()
  },
  methods: {
    select(index) {
      this.selectedIndex = index
      this.updateSlider()
      this.$emit('selectedTab', index)
    },
    updateSlider() {
      this.$nextTick(() => {
        const span = this.$refs['option' + this.selectedIndex]
        const container = this.$refs.container
        if (span && container) {
          const containerRect = container.getBoundingClientRect()
          const spanRect = span.getBoundingClientRect()
          const selectedRightForCalculatedBorder = this.selectedIndex === 1 ? 1 : 0
          this.sliderLeft = spanRect.left - containerRect.left - selectedRightForCalculatedBorder
          this.sliderWidth = spanRect.width
        }
      })
    }
  }
}
</script>

<style scoped>
.toggle-container {
  position: relative;
  display: inline-flex; /* Autoajusta al contenido */
  border: 1px solid #d8d8d8;
  border-radius: 100px;
  padding: 3.5px;
  cursor: pointer;
  overflow: hidden;
}

span {
  padding: 4px 18px;
  font-size: 12px;
  font-weight: 700;
  text-align: center;
  z-index: 1;
  transition: color 0.3s;
  position: relative;
  white-space: nowrap;
}

.active {
  color: white;
}

.slider {
  position: absolute;
  top: 4px;
  bottom: 4px;
  background-color: #29343D;
  border-radius: 100px;
  transition: left 0.3s, width 0.3s;
  z-index: 0;
}
</style>
